var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "push-container" },
    _vm._l(_vm.tableColumn, function (item, index) {
      return _c("div", { key: index, staticStyle: { display: "flex" } }, [
        _c(
          "div",
          {
            staticClass: "push-head",
            style: {
              "border-bottom":
                index < _vm.tableColumn.length - 1 ? "1px solid #ccc" : "",
            },
          },
          [_vm._v(_vm._s(item.label))]
        ),
        _c(
          "div",
          {
            staticStyle: { flex: "1", padding: "10px" },
            style: {
              "border-bottom":
                index < _vm.tableColumn.length - 1 ? "1px solid #ccc" : "",
            },
          },
          [
            item.prop === "pushStatus"
              ? _c(
                  "div",
                  [
                    _vm.detailData.pushStatus === 0
                      ? _c(
                          "el-tag",
                          { attrs: { size: "mini", type: "warning" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.statusOptions[_vm.detailData.pushStatus]
                                    .label
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.detailData.pushStatus === 1
                      ? _c(
                          "el-tag",
                          { attrs: { size: "mini", type: "success" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.statusOptions[_vm.detailData.pushStatus]
                                    .label
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.detailData.pushStatus === 2
                      ? _c(
                          "el-tag",
                          { attrs: { size: "mini", type: "danger" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.statusOptions[_vm.detailData.pushStatus]
                                    .label
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.detailData.pushStatus === 3
                      ? _c(
                          "el-tag",
                          { attrs: { size: "mini", type: "info" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.statusOptions[_vm.detailData.pushStatus]
                                    .label
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : item.prop === "currentMdfeStatus"
              ? _c(
                  "div",
                  [
                    _vm.detailData.currentMdfeStatus === 1
                      ? _c(
                          "el-tag",
                          { attrs: { size: "mini", type: "success" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.mdfeStatus[
                                    _vm.detailData.currentMdfeStatus
                                  ].label
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.detailData.currentMdfeStatus === 2
                      ? _c(
                          "el-tag",
                          { attrs: { size: "mini", type: "danger" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.mdfeStatus[
                                    _vm.detailData.currentMdfeStatus
                                  ].label
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.detailData.currentMdfeStatus === 3
                      ? _c(
                          "el-tag",
                          { attrs: { size: "mini", type: "info" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.mdfeStatus[
                                    _vm.detailData.currentMdfeStatus
                                  ].label
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _c("div", [
                  _vm._v(" " + _vm._s(_vm.detailData[item.prop]) + " "),
                ]),
          ]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }